export default "__VITE_ASSET__BuA_RQLN__"